import { Button, SMALL, TERTIARY } from '@glu/buttons-react';
import locale from '@glu/locale';
import useStyles from './ApplyCancelButtons.styles';

interface IApplyCancelButtonsProps {
  /** Callback for when the apply button is clicked */
  onApply(): void;
  /** Callback for when the cancel button is clicked */
  onCancel(): void;
}

const ApplyCancelButtons = ({ onApply, onCancel }: IApplyCancelButtonsProps) => {
  const classes = useStyles();
  return (
    <div className={classes.applyButtonWrapper}>
      <Button onClick={onApply} size={SMALL}>
        {locale.get('dataComponents.apply')}
      </Button>
      <Button className={classes.cancelButton} onClick={onCancel} size={SMALL} variant={TERTIARY}>
        {locale.get('dataComponents.cancel')}
      </Button>
    </div>
  );
};

export default ApplyCancelButtons;
